import { Outlet } from 'react-router-dom';
import { ThemeProvider, CssBaseline, styled } from '@mui/material';
import mainTheme from './theme';
import { LocalizationProvider } from '@mui/x-date-pickers';
import ModalRoot from './common/components/modal/ModalRoot';
import SnackbarRoot from './common/components/snackbar/SnackbarRoot';
import FullScreenLoaderRoot from './common/components/fullScreenLoader/FullScreenLoaderRoot';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import VersionUpdateAlertSnackbarRoot from './common/components/snackbar/UpdateAlertSnackbarRoot';
import { SnackbarProvider, MaterialDesignContent } from 'notistack';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import { ConfirmProvider } from 'material-ui-confirm';
import WarningAmber from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ModalProvider from './common/components/ConfirmationDialog/ModalProvider';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import 'react-day-picker/style.css';

require('@/utils/dayjs_locale/zh-hk');

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
	'&.notistack-MuiContent-success': {
		backgroundColor: '#F0F7BA',
		color: '#5D5E61',
	},
	'&.notistack-MuiContent-error': {
		backgroundColor: '#FFE0DD',
		color: '#FF5B4D',
		'.MuiSvgIcon-fontSizeMedium': {
			color: '#D32F2F',
		},
	},
	// '&.notistack-MuiContent-default': {
	// 	backgroundColor: '#970C0C', // 使用默認中。設計圖中沒找到相關css，待配置
	// },
	'&.notistack-MuiContent-warning': {
		backgroundColor: '#E0F7FB',
		color: '#5D5E61',
		'.MuiSvgIcon-fontSizeMedium': {
			color: '#495057',
		},
	},
	// '&.notistack-MuiContent-info': {
	// 	backgroundColor: '#E1F5FE',
	// 	color: '#014361',
	// 	'.MuiSvgIcon-fontSizeMedium': {
	// 		color: '#0288D1',
	// 	},
	// },
}));

function App() {
	return (
		<ThemeProvider theme={mainTheme}>
			<SnackbarProvider
				maxSnack={3}
				Components={{
					default: StyledMaterialDesignContent,
					success: StyledMaterialDesignContent,
					error: StyledMaterialDesignContent,
					warning: StyledMaterialDesignContent,
					info: StyledMaterialDesignContent,
				}}
				iconVariant={{
					// success: <CheckCircleOutlined sx={{ marginRight: '15px' }} />,
					// warning: <WarningAmber sx={{ marginRight: '15px' }} />,
					// error: <ErrorOutlineIcon sx={{ marginRight: '15px' }} />,
					// info: <InfoOutlinedIcon sx={{ marginRight: '15px' }} />,
					success: <></>,
					error: <></>,
					warning: <></>,
					info: <></>,
					// 使用默認中。default error warning info待配置
				}}
			>
				<ConfirmProvider>
					<ModalProvider>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<CssBaseline />
							<Outlet />
							<ModalRoot />
							<SnackbarRoot />
							<FullScreenLoaderRoot />
							<VersionUpdateAlertSnackbarRoot />
						</LocalizationProvider>
					</ModalProvider>
				</ConfirmProvider>
			</SnackbarProvider>
		</ThemeProvider>
	);
}

export default App;
